import type React from 'react'
 
export const reportAccessibility = async (
  App: typeof React,
  config?: Record<string, unknown>
): Promise<void> => {
  if (
    typeof window !== "undefined" &&
    (process.env.NEXT_PUBLIC_ITNL_STORE_ENV !== 'production' && process.env.ITNL_STORE_ENV !== undefined)
  ) {

    const axe = await import('@axe-core/react');
    const ReactDOM = await import('react-dom');
 
    axe.default(App, ReactDOM, 1000, config);
  }
}
 
export default reportAccessibility